import { render, staticRenderFns } from "./StaffNotificationModal.vue?vue&type=template&id=14889783&scoped=true"
import script from "./StaffNotificationModal.vue?vue&type=script&lang=js"
export * from "./StaffNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./StaffNotificationModal.vue?vue&type=style&index=0&id=14889783&prod&scoped=true&lang=css"
import style1 from "./StaffNotificationModal.vue?vue&type=style&index=1&id=14889783&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14889783",
  null
  
)

export default component.exports